import './style.scss';

document.addEventListener('DOMContentLoaded', function () {
  const links = document.querySelectorAll('.recommended_posts__content a');
  const container = document.querySelector(
    '.recommended_posts__fullbleed_display',
  );
  const background = document.querySelector('.recommended_posts__background');
  let activeLink = null; // Store the currently active link

  function changeBackground(url, link) {
    background.style.backgroundImage = `url('${url}')`;
    if (activeLink) {
      activeLink.classList.remove('active'); // Remove active class from previously active link
    }
    link.classList.add('active'); // Add active class to new active link
    activeLink = link; // Update active link
  }

  // Adjust thresholds based on device width
  function getThresholds() {
    const viewportWidth = window.innerWidth;
    const viewportHeight = window.innerHeight;

    if (viewportWidth >= 768 && viewportWidth <= 1400) {
      // Tablet sizes
      // Custom thresholds for tablets due to footer and less scrollable area
      return {
        firstThreshold: (3 * viewportHeight) / 4, // Lower threshold for tablets
        secondThreshold: (3 * viewportHeight) / 4 + 200, // Lower second threshold for tablets
      };
    } else {
      // Default thresholds for non-tablet devices
      return {
        firstThreshold: (2 * viewportHeight) / 3,
        secondThreshold: (5 * viewportHeight) / 6 + 100,
      };
    }
  }

  function handleScroll() {
    if (!container || !links.length || !background) return;

    const { firstThreshold, secondThreshold } = getThresholds();
    const containerRect = container.getBoundingClientRect();
    const position = window.innerHeight - containerRect.top;

    if (position < firstThreshold) {
      changeBackground(links[0].dataset.bg, links[0]);
    } else if (position >= firstThreshold && position < secondThreshold) {
      changeBackground(links[1].dataset.bg, links[1]);
    } else if (position >= secondThreshold) {
      changeBackground(links[2].dataset.bg, links[2]);
    }
  }

  function handleHover() {
    links.forEach((link, index) => {
      link.addEventListener('mouseenter', () => {
        changeBackground(links[index].dataset.bg, links[index]);
      });
    });
  }

  // Detect touch capability
  const isTouchDevice = window.matchMedia('(hover: none)').matches;

  if (isTouchDevice) {
    // Using passive event listeners
    window.addEventListener('scroll', handleScroll, { passive: true });
    handleScroll(); // Trigger on load
  } else {
    handleHover();
  }
});
